import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import { PrimaryButton } from "../../elements/Button";

type CampaignTemplatesEmptyStateProps = {
  onNewTemplate: () => void;
};

const Root = styled("div")({
  padding: "56px 32px",
  textAlign: "center",
});

const IconWrap = styled("div")(({ theme }: { theme: Theme }) => ({
  width: 56,
  height: 56,
  borderRadius: 14,
  background: theme.palette.brand.gray100,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 16,
  border: `1px solid ${theme.palette.brand.gray200}`,
}));

const Title = styled("h3")(({ theme }: { theme: Theme }) => ({
  margin: 0,
  fontSize: 15,
  fontWeight: 600,
  color: theme.palette.brand.gray700,
}));

const Description = styled("p")(({ theme }: { theme: Theme }) => ({
  margin: "6px 0 20px",
  fontSize: 13,
  color: theme.palette.brand.gray500,
  maxWidth: 420,
  marginLeft: "auto",
  marginRight: "auto",
  lineHeight: 1.5,
}));

const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const TemplatesIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);

const CampaignTemplatesEmptyState: FC<CampaignTemplatesEmptyStateProps> = ({ onNewTemplate }) => (
  <Root>
    <IconWrap>
      <TemplatesIcon />
    </IconWrap>
    <Title>No templates yet</Title>
    <Description>
      Templates help you speed up campaign creation. Create your first template to reuse campaign settings and steps.
    </Description>
    <PrimaryButton type="button" onClick={onNewTemplate}>
      <PlusIcon />
      Create Template
    </PrimaryButton>
  </Root>
);

export default CampaignTemplatesEmptyState;
